import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, InputBase, Typography, ButtonBase } from '@material-ui/core';
import ClassNames from 'classnames';
import update from 'immutability-helper';
import CheckedIcon from './images/checked.svg';
import UncheckedIcon from './images/unchecked.svg';

const useStyles = makeStyles(() => ({
  root: {},
  title: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 19,
    marginBottom: 18,
  },
  optionBtn: {
    display: 'flex',
    justifyContent: 'flex-start',
    opacity: 0.99,
    border: '1px solid #E3E3E3',
    borderRadius: 5,
    padding: '9px 13px',
    fontSize: 17,
    lineHeight: '22px',
    marginBottom: 4,
    textAlign: 'left',
    '& img': {
      marginRight: 11,
    },
  },
  active: {
    border: '1px solid #0063A2',
    color: '#0063A2',
  },
  textarea: {
    marginTop: 18,
    marginBottom: 13,
    width: '100%',
    background: '#FFFFFF',
    border: '1px solid #E9ECED',
    borderRadius: 10,
    padding: '10px 18px',
    fontSize: 14,
  },
  btn: {
    background: '#01619B',
    borderRadius: 6,
    color: 'white',
    fontSize: 14,
    fontFamily: 'MadaBold',
    width: 148,
    height: 42,
    marginTop: 13,
  },
}));

function Questions({ submit, data, type, otherPlaceholder, submitLabel }) {
  const classes = useStyles();
  const [secondaryValue, setSecondaryValue] = useState([]);
  const [textualValue, setTextualValue] = useState('');
  const [secondaryValueReadable, setSecondaryValueReadable] = useState([]);
  const [otherSelected, setOtherSelected] = useState('');
  const { header, options } = data;

  useEffect(() => {
    setSecondaryValue([]);
    setTextualValue('');
    setSecondaryValueReadable([]);
    setOtherSelected('');
  }, [type]);

  const onSelect = ({ value, other, label }) => {
    const valueIndex = secondaryValue.indexOf(value);
    if (valueIndex === -1) {
      setSecondaryValue(
        update(secondaryValue, {
          $push: [value],
        }),
      );
      setSecondaryValueReadable(
        update(secondaryValueReadable, {
          $push: [label],
        }),
      );
    } else {
      setSecondaryValue(
        update(secondaryValue, {
          $splice: [[valueIndex, 1]],
        }),
      );
      setSecondaryValueReadable(
        update(secondaryValueReadable, {
          $splice: [[valueIndex, 1]],
        }),
      );
    }
    if (other) {
      setOtherSelected(`${value}`);
    }
    if (
      value === parseInt(otherSelected, 10) &&
      secondaryValue.includes(parseInt(otherSelected, 10))
    ) {
      setOtherSelected('');
      setTextualValue('');
    }
  };

  const handleTextualChange = event => setTextualValue(event.target.value);

  return (
    <>
      <Box component="div">
        <Typography className={classes.title}>{header}</Typography>
      </Box>
      <Box component="div" display="flex" flexDirection="column">
        {options.map(({ label, value, other }) => (
          <ButtonBase
            disableRipple
            className={ClassNames(classes.optionBtn, {
              [classes.active]: secondaryValue.includes(value),
            })}
            onClick={() => onSelect({ value, other, label })}
          >
            <img
              src={secondaryValue.includes(value) ? CheckedIcon : UncheckedIcon}
              alt=""
            />
            {label}
          </ButtonBase>
        ))}
      </Box>
      {!!secondaryValue.length && (
        <Box>
          <InputBase
            className={classes.textarea}
            placeholder={otherPlaceholder}
            multiline
            rows={3}
            onChange={handleTextualChange}
            autoComplete="off"
          />
        </Box>
      )}
      <Box component="div" display="flex" justifyContent="flex-end">
        <ButtonBase
          onClick={() =>
            submit(
              type === 'like',
              {
                secondaryValue,
                textualValue,
                secondaryValueReadable,
              },
              true,
            )
          }
          className={classes.btn}
        >
          {submitLabel}
        </ButtonBase>
      </Box>
    </>
  );
}

Questions.propTypes = {
  submit: PropTypes.func,
  otherPlaceholder: PropTypes.string,
  data: PropTypes.object,
  type: PropTypes.string,
  submitLabel: PropTypes.string,
};

export default Questions;
